/* eslint-disable */

import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {

    namespaced: true,
    state: {
        data: [],
    },
    mutations: {

    },
    actions: {

        async resolveBookingUrl({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                // Tell the API which page linked here (document.referrer) so it can log who published a short link.
                const ref = (typeof document !== 'undefined' && document && document.referrer) || '';
                let response = await axios.get(`/resolve-booking-url/${payload.urlID}`, {
                    crossdomain: true,
                    params: ref ? { ref: ref.slice(0, 300) } : {},
                });
                dispatch('alert/setLoaded', true, {root: true});
                return response;
            } catch(err) {
                console.log('Error resolving booking url:', err);
                // Not the page-level alert: its text was the raw axios error ("Request failed with status code 404")
                // on a patient-facing page. The page shows its own plain message from { failed, status }.
                dispatch('alert/setLoaded', true, {root: true});
                return { failed: true, status: err && err.response ? err.response.status : undefined };
            }
        }
    }
}
